export class Config {
  environment: {
    isProduction: boolean;
  };

  debug: {
    useCloud: boolean;
  };
}
